import React from "react"
import { AspectRatio, Grid, GridItem } from "@chakra-ui/react"
import Image from "@app/components/Image/Image"

export interface ProductMediaDesktopProps {
  images: any[]
  onOpen: () => void
  maxHeight: string
}

const ProductMediaDesktop = ({ images, onOpen, maxHeight = "100%" }: ProductMediaDesktopProps) =>
  images.length ? (
    <Grid templateColumns={images?.length == 1 ? "repeat(1, 1fr)" : "repeat(2, 1fr)"} gap={2.5}>
      {images.map((image: any, index: number) => (
        <GridItem key={index} onClick={() => onOpen(index)}>
          <AspectRatio ratio={404 / 525}>
            <Image src={image?.src} alt={image?.alt} cursor={"zoom-in"} maxHeight={maxHeight} />
          </AspectRatio>
        </GridItem>
      ))}
    </Grid>
  ) : null

export default ProductMediaDesktop
